import React, { lazy, Suspense } from 'react';

import { Loader } from '../common/components/Loader';

const LazyChatbot = lazy(() => {
  return import('./Chatbot' /* webpackChunkName: "Chatbot" */).then((i) => ({
    default: i.default,
  }));
});

export const Chatbot = () => (
  <Suspense fallback={<Loader height="100%" verticalAlign="middle" width="100%" />}>
    <LazyChatbot />
  </Suspense>
);
